<template>
  <div class="modal fade" ref="mdlFiltrosRouters" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog"  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Filtros Routers</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <p>
            Da click sobre el switch deseado para realizar el filtrado:
          </p>

          <div class="row">
            <div class="col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="en_linea"
                  @change="actualizarRouters()"
                  class="form-check-input"
                  type="checkbox"
                  id="enLinea"
                />
                <label class="form-check-label" for="enLinea">
                  Conectados a la VPN
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="desconectados"
                  @change="actualizarRouters()"
                  class="form-check-input"
                  type="checkbox"
                  id="desconectados"
                />
                <label class="form-check-label" for="desconectados">
                  Desconectados de la VPN
                </label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="conexion_api"
                  @change="actualizarRouters()"
                  class="form-check-input"
                  type="checkbox"
                  id="conexionApi"
                />
                <label class="form-check-label" for="conexionApi">
                  Conexión a la API conectada
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-check form-switch form-switch-lg mb-3" dir="ltr">
                <input
                  v-model="error_api"
                  @change="actualizarRouters()"
                  class="form-check-input"
                  type="checkbox"
                  id="errorApi"
                />
                <label class="form-check-label" for="errorApi">
                  Conexión a la API con error
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from 'bootstrap/js/dist/modal'

export default {
  name: 'MdlFiltrosRouters',
  props: {
    en_linea_router: {
      type: Boolean,
      default: false
    },
    desconectados_router: {
      type: Boolean,
      default: false
    },
    conexion_api_router: {
      type: Boolean,
      default: false
    },
    error_api_router: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      en_linea:       ["1", 1, "true", true].includes(this.en_linea_router),
      desconectados:  ["1", 1, "true", true].includes(this.desconectados_router),
      conexion_api:   ["1", 1, "true", true].includes(this.conexion_api_router),
      error_api:      ["1", 1, "true", true].includes(this.error_api_router),
    }
  },
  methods: {
    actualizarRouters() {
      let self = this

      self.$emit('actualizar-routers', {
        en_linea: self.en_linea,
        desconectados: self.desconectados,
        conexion_api: self.conexion_api,
        error_api: self.error_api
      })
    },

    mostrar() {
      var self = this
      var modal = new Modal(this.$refs.mdlFiltrosRouters)
      modal.show()
    },
  }
}
</script>
